export { default, getModalConfig, type OpenModalProps } from './Modal';
export { default as shouldOpenModal } from './shouldOpenModal';
